export default "__VITE_ASSET__Ch$zu2Nr__"